/*
|--------------------------------------------------------------------------
| Analytics: Parse.ly
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.analytics.parsely = {

	/**
	 * Track Parse.ly
	 * @param {object} options
	 * @param {string} options.path - path portion of url (ie "/url-path")
	 * @param {string} [options.title=null] - title
	 */
	"preload": {
		eventQueue: [],
		loaded: false
	},

	"init":function(){
		var parsely = this;
	    PARSELY = {
	        autotrack: false,
	        onload: function() {
		        parsely.preload.loaded = true;
		        for (var i = 0; i < parsely.preload.eventQueue.length; i++) {
		            PARSELY.beacon.trackPageView(parsely.preload.eventQueue[i]);
		        }
	        }
	    };
	},

	"track":function(options){
		var url 		= (options.url) ? options.url : document.location.href,
			urlref 		= (options.urlref) ? options.urlref : document.referrer;
			parsely 	= this;

	    var event = {
	        url: url,
	        urlref: urlref,
	        js: 1,
	        action_name: "Next Post"
	    };
	    if(parsely.preload.loaded){
	        PARSELY.beacon.trackPageView(event);
	    }else{
	        parsely.preload.eventQueue.push(event);
	    }
	}
};
